import { render, staticRenderFns } from "./NewsWidget.vue?vue&type=template&id=5f9456e5&scoped=true"
import script from "./NewsWidget.vue?vue&type=script&lang=js"
export * from "./NewsWidget.vue?vue&type=script&lang=js"
import style0 from "./NewsWidget.vue?vue&type=style&index=0&id=5f9456e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9456e5",
  null
  
)

export default component.exports